import { render, staticRenderFns } from "./internshipResult.vue?vue&type=template&id=1e10f3dc&"
import script from "./internshipResult.vue?vue&type=script&lang=js&"
export * from "./internshipResult.vue?vue&type=script&lang=js&"
import style0 from "./internshipResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports